import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-28 overflow-hidden">
      {/* Colorful gradient background */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #38BDF8 0%, #F472B6 50%, #FBBF24 100%)' }} />
      {/* Decorative circles */}
      <div className="absolute top-8 left-16 w-32 h-32 bg-white/10 rounded-full" />
      <div className="absolute bottom-8 right-16 w-24 h-24 bg-white/10 rounded-full" />
      <div className="absolute top-1/2 left-8 w-16 h-16 bg-white/15 rounded-xl rotate-12" />
      <div className="absolute top-1/3 right-12 w-12 h-12 bg-white/20 rounded-full" />
      <div className="absolute bottom-16 left-1/3 w-8 h-8 bg-white/25 rounded-full" />

      {/* Content */}
      <div className="relative z-10 text-center max-w-3xl mx-auto px-6">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-black px-5 py-2.5 rounded-full mb-8 tracking-wider uppercase backdrop-blur-sm">
          🚀 YOUR BRAND, OUR MISSION
        </div>
        <h2 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6 drop-shadow-sm">
          一緒に、最高の<br />
          <span className="bg-white/20 px-4 rounded-2xl">ブランドをつくろう！</span>
        </h2>
        <p className="text-white/90 text-sm md:text-base leading-relaxed mb-10 max-w-xl mx-auto font-medium">
          まずはお気軽にご相談ください🎉<br />
          私たちがあなたのビジョンを現実にする最適なプランをご提案します。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-white text-gray-900 font-black px-8 py-4 rounded-full cursor-pointer hover:scale-105 transition-all whitespace-nowrap"
          >
            <i className="ri-mail-send-fill text-lg text-[#F472B6]" />
            無料相談はこちら
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white font-black px-8 py-4 rounded-full cursor-pointer hover:bg-white/10 transition-all whitespace-nowrap"
          >
            サービスを確認する
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
